import React, {useState,useEffect} from 'react';

import '../App.css';

function Output({ tasks,deleteTask  }) {
    const [completedTasks, setCompletedTasks] = useState([]);

    useEffect(() => {
        const savedCompletedTasks = JSON.parse(localStorage.getItem('completedTasks')) || [];
        setCompletedTasks(savedCompletedTasks);
      }, []);
    
      // Save completed tasks to localStorage whenever they change
      useEffect(() => {
        if (completedTasks.length > 0) {
          localStorage.setItem('completedTasks', JSON.stringify(completedTasks));
        }
      }, [completedTasks]);

    const handleCheckboxChange = (index) => {
        setCompletedTasks((prevState) => {
          if (prevState.includes(index)) {
            return prevState.filter((taskIndex) => taskIndex !== index);
          } else {
            return [...prevState, index];
          }
        });
      };


  return (
    <div>
      <h3>Todo List</h3>
      <ul className='list'>
      {tasks.map((task, index) => (
        <li className='list-li' key={index} style={{ color: completedTasks.includes(index) ? 'limegreen' : 'white' }}>
        <label>
            <input type='checkbox' className='check'
             onChange={() => handleCheckboxChange(index)} // Toggle task completion
             checked={completedTasks.includes(index)}
            />
            {task}
        </label>
        <button className='btn-delete' onClick={() => deleteTask(index)}>x</button>
    </li>
      ))}
      </ul>
    </div>
  )
}

export default Output